import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex-cell" }

import { mdiCheckboxMarkedCircle } from "@mdi/js";
import SvgIcon from "@jamescoyle/vue-icon";

import { defineComponent, PropType, ref } from "vue";

const __default__ = defineComponent({
  name: "RfpTitleGridRenderer",

});


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    params: {}
  },
  setup(__props: any) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", null, _toDisplayString(_ctx.params.value) + " (" + _toDisplayString(_ctx.params.data?.id) + ") ", 1),
    (_ctx.params.data?.closed_at !== null)
      ? (_openBlock(), _createBlock(_unref(SvgIcon), {
          key: 0,
          type: "mdi",
          path: _unref(mdiCheckboxMarkedCircle)
        }, null, 8, ["path"]))
      : _createCommentVNode("", true)
  ]))
}
}

})